/**
 * ConfidenceBadge — color-coded pill rendered on each section row in the
 * From-an-Ad preview pane.
 *
 *   value ≥ 0.75 → ● High      (teal)
 *   value 0.5–0.74 → ● Medium  (amber)
 *   value < 0.5  → ○ Not inferred (slate)
 */

interface Props {
  value: number;
}

export function ConfidenceBadge({ value }: Props) {
  const v = Math.max(0, Math.min(1, value));
  let label: string;
  let cls: string;
  if (v >= 0.75) {
    label = '● High';
    cls = 'bg-teal-50 text-teal-700 border-teal-200';
  } else if (v >= 0.5) {
    label = '● Medium';
    cls = 'bg-amber-50 text-amber-700 border-amber-200';
  } else {
    label = '○ Not inferred';
    cls = 'bg-slate-50 text-slate-400 border-slate-200';
  }
  return (
    <span
      className={`text-[9px] font-semibold uppercase px-1.5 py-0.5 rounded-full border whitespace-nowrap ${cls}`}
      title={`Confidence ${(v * 100).toFixed(0)}%`}
    >
      {label}
    </span>
  );
}
